import { DefaultModal, DefaultModalProps, ModalType } from '@frontend/components/mobile';

import { useMobileDragModal } from './mobile-drag-modal.controller';

export interface MobileDragModalProps extends DefaultModalProps {
    height?: number;
}

export const MobileDragModal = (props: MobileDragModalProps) => {
    useMobileDragModal(props);

    return (
        <DefaultModal
            handleClose={props.handleClose}
            show={props.show}
            type={ModalType.MOBILE_BOTTOM}
            className={`bg-foreground-default absolute bottom-0 z-1001 h-fit ${props.height ? `max-h-[${props.height}%]` : 'max-h-[55%]'} w-full overflow-hidden`}>
            <div className='w-full px-5 pt-2 pb-12'>
                <div
                    id='mobile-drag'
                    className='bg-foreground-default flex justify-center pb-4'>
                    <hr className='text-background-surface w-24 rounded-full border-2'></hr>
                </div>
                {props.children}
            </div>
        </DefaultModal>
    );
};
